import { apiUrl } from "../enviroments/enviroments.dev";
import { Api } from "./Api";

const target = "/wallets";

export interface ProfitActionPayload {
    organization_id: number;
    value: number;
}

export class ProfitService {

    // Saque da carteira de lucro — endpoint owner-only no otc-core.
    public static withdraw(payload: ProfitActionPayload) {
        return Api.post(apiUrl(target + "/withdraw"), payload);
    }

    // Envio da carteira de lucro para a carteira Default (caixa) da empresa
    // — endpoint owner-only no otc-core.
    public static transferToCompany(payload: ProfitActionPayload) {
        return Api.post(apiUrl(target + "/profit/transfer-to-company"), payload);
    }

}
